import React from "react";
import classes from "./hero.module.css";
import styled from "styled-components";
import Card from "../heroCard/Card";
import VideoCard from "../heroCard/VideoCard";
import image3 from "../../assets/image3.jpg";
import banarasi1 from "../../assets/banarasi1.jpg";
import lehenga1 from "../../assets/lehenga1.jpg";
import lehenga2 from "../../assets/lehenga2.jpg";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { laptopsm, tab, tabsm, desktop } from "../../responsive";
const HeroContainer = styled.div`
  display: flex;
  /* height: 600px; */
  overflow: hidden;
  transition: all 0.2s ease-out;
  ${laptopsm({ height: "400px !important" })};
  ${tab({ height: "350px !important" })};
  ${tabsm({ height: "300px !important" })};
  ${desktop({ height: "500px !important" })};
`;

const Hero = () => {
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 900,
    arrows: false,
    easing: "ease-out",
    pauseOnHover: false
  };

  return (
    <HeroContainer className={classes.HeroContainer}>
      <div className={classes.hero__left}>
        <Slider {...settings}>
          <Card
            img={banarasi1}
            title="Sarees & Ethinics"
            desc="30% OFF FOR NEW ARRIVALS"
            className={classes.cardLeft}
          />
          <Card
            img={lehenga1}
            title="Wedding Lehangas"
            desc="30% OFF FOR NEW ARRIVALS"
            className={classes.cardLeft}
          />
        </Slider>
      </div>
      <div className={classes.hero__middle}>
        <VideoCard />
      </div>
      <Slider {...settings} className={classes.hero__right}>
        <Card
          img={image3}
          title="Casual wears"
          desc="30% OFF FOR NEW ARRIVALS"
          className={classes.cardLeft}
        />
        <Card
          img={lehenga2}
          title="Wedding Lehangas"
          desc="30% OFF FOR NEW ARRIVALS"
          className={classes.cardLeft}
        />
      </Slider>
    </HeroContainer>
  );
};

export default Hero;
